import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import TableComponent from "../../../components/tableComponent";
import {
  actionsColumn,
  textColumn
} from "../../../components/tableComponent/columns";
import CreateEditFeaturesModal from "./createEditFeatureModal";
import FeatureStatusToggleIcon from "./FeatureStatusToggleIcon";
import {
  callApiAsync,
  featuresCreateOrUpdate,
  getFeaturesByProduct,
  updateFeatureStatus
} from "../../../services/apiService";
import ModalComponent from "../../../components/modalComponent";
import ToastNotification from "../../../components/toastNotification";
import ButtonComponent from "../../../components/button";
import icons from "../../../constants/icons";
import StatusPill from "../../../components/statusPill";

const readFeatureStatus = (row) => {
  const raw = row?.status ?? row?.Status;
  if (raw === undefined || raw === null) return 1;
  return Number(raw) === 0 ? 0 : 1;
};

const FeaturesModal = ({ rowDataProduct, open, onClose }) => {
  const userData = useSelector((state) => state.user?.userData);
  const [openCreateEdit, setOpenCreateEdit] = useState(false);
  const [featuresData, setFeaturesData] = useState([]);
  const [selectedRow, setSelectedRow] = useState({});
  const [toastMessage, setToastMessage] = useState("");
  const [toastOpen, setToastOpen] = useState(false);
  const [toastSeverity, setToastSeverity] = useState("warning");

  const getFeaturesTable = () => {
    callApiAsync(
      () => getFeaturesByProduct(rowDataProduct.id),
      (data) => {
        setFeaturesData(Array.isArray(data) ? data : []);
      }
    );
  };

  useEffect(() => {
    if (open && rowDataProduct?.id) getFeaturesTable();
  }, [rowDataProduct, open]);

  const createUpdateFeature = (featureData) => {
    callApiAsync(
      () => featuresCreateOrUpdate(featureData),
      () => {
        getFeaturesTable();
      }
    );
  };

  const toggleFeatureStatus = (row) => {
    const currentStatus = readFeatureStatus(row);
    const newStatus = currentStatus === 1 ? 0 : 1;
    callApiAsync(
      () =>
        updateFeatureStatus({
          id: row.id,
          status: newStatus,
          email: userData?.email ?? ""
        }),
      () => {
        setFeaturesData((prev) =>
          prev.map((f) => (f.id === row.id ? { ...f, status: newStatus } : f))
        );
        setToastSeverity("success");
        setToastMessage(
          newStatus === 1
            ? "Feature activado."
            : "Feature inactivado (se conserva en histórico)."
        );
        setToastOpen(true);
        getFeaturesTable();
      },
      (err) => {
        setToastSeverity("error");
        setToastMessage(err?.response?.data || err?.message || err || "Error al actualizar.");
        setToastOpen(true);
      }
    );
  };

  const handleCreateEdit = (row) => {
    if (!row) {
      setSelectedRow({});
      setOpenCreateEdit(true);
      return;
    }
    setSelectedRow(row);
    setOpenCreateEdit(true);
  };

  const actionBtn = ({ row }) => (
    <div className="HContainer">
      <ButtonComponent
        onClick={() => toggleFeatureStatus(row.original)}
        variant="contained"
        backgroundColor="#fff0"
        title="Cambiar estado activo/inactivo"
      >
        <FeatureStatusToggleIcon />
      </ButtonComponent>
      <ButtonComponent
        onClick={() => handleCreateEdit(row.original)}
        variant="contained"
        backgroundColor="#fff0"
      >
        <img className="btn-icon" src={icons.blue_edit} alt="icon" />
      </ButtonComponent>
    </div>
  );

  const handleClose = () => {
    setOpenCreateEdit(false);
  };

  const columns = useMemo(
    () => [
      textColumn("name", "Nombre del Característica / Features"),
      {
        id: "status",
        header: "Estado",
        size: 100,
        Cell: ({ row }) => {
          const isActive = readFeatureStatus(row.original) === 1;
          return (
            <StatusPill
              backgroundColor={isActive ? "#4ADE80" : "#D9D9D9"}
              textColor="#000"
            >
              {isActive ? "Activo" : "Inactivo"}
            </StatusPill>
          );
        }
      },
      actionsColumn(actionBtn, 100, "Acciones")
    ],
    [userData?.email]
  );

  return (
    <div>
      <ModalComponent
        open={open}
        onClose={onClose}
        title={"Característica / Features"}
      >
        <TableComponent
          columns={columns}
          data={featuresData}
          enableGlobalFilter={true}
          headerButtons={() => (
            <ButtonComponent
              onClick={() => handleCreateEdit()}
              type="submit"
              variant="contained"
              backgroundColor="#F6C079"
              textColor="#000000"
              margin="15px 0"
            >
              <div className="HContainer a-center">
                <img
                  className="btn-icon icon-margin-r-15"
                  src={icons.plus}
                  alt="icon"
                />
                <p>Crear Característica / Features</p>
              </div>
            </ButtonComponent>
          )}
        />

        <CreateEditFeaturesModal
          tableData={featuresData}
          rowData={selectedRow}
          open={openCreateEdit}
          onClose={handleClose}
          idMainProduct={rowDataProduct}
          onSubmitFuntion={createUpdateFeature}
        />
      </ModalComponent>
      <ToastNotification
        open={toastOpen}
        handleClose={() => setToastOpen(false)}
        message={toastMessage}
        severity={toastSeverity}
      />
    </div>
  );
};

export default FeaturesModal;
